import { mutatorAction } from "satcheljs";
import { getStore } from "../store/store";

/**
 * Set the unread conversations count in the theme creator store
 * @param count the unread conversations count to set
 */
const setUnreadConversationsCountMutator: (count: number) => void = mutatorAction("setTeamsUnreadConversationsCount", (count: number): void => {
    getStore().unreadConversationsCount = count;
});

export default setUnreadConversationsCountMutator;
